import { render, staticRenderFns } from "./FormNumber.vue?vue&type=template&id=2064be90&scoped=true"
import script from "./FormNumber.vue?vue&type=script&lang=js"
export * from "./FormNumber.vue?vue&type=script&lang=js"
import style0 from "./FormNumber.vue?vue&type=style&index=0&id=2064be90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2064be90",
  null
  
)

export default component.exports